import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

// 管理员
export default {
  getUrlsList(params) { // 获取系统管理路径
    const url =  baseURL + '/tbSysmanage/list';
    return axios.post(url, qs.stringify(params));
  },
  upUrls(params) { // 修改系统管理路径
    const url =  baseURL + '/tbSysmanage/modify';
    return axios.post(url, qs.stringify(params));
  },
  
  delUrls(params) { // 删除系统管理路径
    const url =  baseURL + '/tbSysmanage/delete';
    return axios.post(url, qs.stringify(params));
  },
 
  
}


// WEBPACK FOOTER //
// ./src/api/urls.js